module.exports = __webpack_public_path__ + "static/media/cargosBanner.eb1b2a82.png";